// For full API documentation, including code examples, visit https://wix.to/94BuAAs

	
	// animation for 'inquire now' button
	  

$w.onReady(function () {
	//TODO: write your page related code here...
	
	// animation for inquire now button

	// set ALT attribute for background images on tours/themes repeaters - waiting for response: https://community.wix.com/partners/forum/partner-announcements/feature-release-alt-text-for-background-images
	// if this is usde, consider applying onclick events for background images, instead of the 'button' element that is repeated.
	// -Eyal, Jun 23, 2020.
	/*
	$w('#toursacrossisrael').forEachItem( ($item, itemData, index) => {
		//let repeatedElement = $item("#repeatedElement");
		
			
		} );*/
	
});


